import {Component, inject} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-qrcode-join-group-modal',
  standalone: true,
  imports: [],
  templateUrl: './qrcode-join-group-modal.component.html',
  styleUrl: './qrcode-join-group-modal.component.scss'
})
export class QrcodeJoinGroupModalComponent {
  activeModal = inject(NgbActiveModal)
}
